import { useRuntimeConfig } from 'nuxt/app';
import { useBookingStore } from '~/stores/booking';

export interface IStandardPackages {
    package_name: string;
    number_of_sessions: number;
    price: number;
};

export const fetchStandardPackages = async (location_id: string) => {
    const config = useRuntimeConfig();
    const isDev = config.public.environment === 'dev';

    const baseUrl = isDev ?
        'https://package-service-dev.ultimateperformance.com/api/packages/standard' :
        'https://package-service.ultimateperformance.com/api/packages/standard';

    try {
        const response = await fetch(`${baseUrl}/${location_id}`);

        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const resp = await response.json();
        const bookingStore = useBookingStore();

        if (resp.data.length > 0) {
            bookingStore.updateBookingState({
                standard_packages: resp.data,
                is_pricing_panel_enabled: true,
            });
        }
    } catch (error) {
        console.error('Error fetching packages:', error);
    }
};

export const resetStandardPackages = () => {
    const bookingStore = useBookingStore();
    bookingStore.updateBookingState({
        standard_packages: [],
        is_pricing_panel_enabled: false,
    });
};
